<!--
  AI:
  Status: "confirmed"
  Type: Component
  SubType: CrudIntegration
  Reason: ObjectBaseComponent template for LogicFlowTestCase entity — active/last-run status badges and generic CRUD form.
-->

@if (initialized && dto) {
    <div class="p-3">
        <div class="flex align-items-center gap-2 mb-3">
            <p-tag [value]="activeLabel" [severity]="activeSeverity"></p-tag>
            @if (dto.lastRunAt) {
                <p-tag [value]="lastRunLabel" [severity]="lastRunSeverity"></p-tag>
                <span class="text-sm text-color-secondary">
                    <i class="fa-regular fa-clock mr-1"></i>{{ dto.lastRunDurationMs }}ms
                </span>
            }
        </div>

        <!-- AI: CRUD Object Component for LogicFlowTestCase editing -->
        <mvs-crud-object
            [objectType]="'lg.LogicFlowTestCase'"
            [objectId]="objectIdentifier.objectId"
            (onChangedObject)="refreshObject(false)">
        </mvs-crud-object>
    </div>
}
